<template>
    <el-pagination
        class="mt-3"
        background
        v-if="pagination && pagination.total_pages > 1"
        :page-size="pagination.per_page"
        :current-page="pagination.current_page"
        @size-change="(e) => $emit('size-change', e)"
        @current-change="(e) => $emit('current-change', e)"
        :disabled="disabled"
        :total="pagination.total"
    >
    </el-pagination>
</template>
<script>
export default {
    props: {
        pagination: {
            required: true,
        },
        disabled: {
            default: false,
        },
    },
};
</script>

<style scoped></style>
